<template>
	<span
		v-if="hasBadge"
		class="organization-profile-status-badge"
		:class="badgeClass"
	>
		{{ displayLabel }}
	</span>
</template>

<script>
import { ORGANIZATION_PROFILE_STATUS_BADGES } from '@/config/settingsConstants'

/**
 * Status badge for organization profile workflow states.
 */
export default {
	computed: {
		badgeClass() {
			return `organization-profile-status-badge--${this.badgeConfig.modifier}`
		},

		badgeConfig() {
			return (
				ORGANIZATION_PROFILE_STATUS_BADGES[this.normalizedStatus] ||
				null
			)
		},

		displayLabel() {
			return this.badgeConfig?.label || ''
		},

		hasBadge() {
			return Boolean(this.badgeConfig)
		},

		normalizedStatus() {
			return String(this.status || '').toLowerCase()
		},
	},
	name: 'OrganizationProfileStatusBadge',

	props: {
		status: {
			default: '',
			type: String,
		},
	},
}
</script>
